/// FOURJS_START_COPYRIGHT(D,2014)
/// Property of Four Js*
/// (c) Copyright Four Js 2014, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("ComboBoxLayoutEngine", ["LeafLayoutEngine"], function (context, cls) {
  /**
   * @class ComboBoxLayoutEngine
   * @memberOf classes
   * @extends classes.LeafLayoutEngine
   */
  cls.ComboBoxLayoutEngine = context.oo.Class(cls.LeafLayoutEngine, function ($super) {
    return /** @lends classes.ComboBoxLayoutEngine.prototype */ {
      __name: "ComboBoxLayoutEngine",

      /**
       * Store the data content text for measure operation
       */
      _localLongestText: "",

      /**
       * Put all entries as a list in the HTML element
       * So the width will be computed from this when measuring DOM Element
       * Also store any text so we can get the height again
       * @inheritDoc
       */
      prepareDynamicMeasure: function () {
        if (!this._dataContentMeasure) {
          return;
        }
        if (this._widget.getLayoutInformation().getCurrentSizePolicy().isFixed()) {
          return;
        }

        let itemsHtml = this._textSample + "<br>";
        // Get the items text of the Combobox
        this._localLongestText = this._widget.getItems().reduce((currentText, item) => {
          itemsHtml += `${item.text}<br>`;
          return currentText.length > item.text.length ? currentText : item.text;
        }, this._textSample);

        this._dataContentMeasure.innerHTML = itemsHtml;
      },

      /**
       * Get the width with all items as list
       * then set any text to compute the height
       * @inheritDoc
       */
      DOMMeasure: function () {
        let elementRects = this._widget.getElement().getBoundingClientRect();
        const width = elementRects.width;
        if (!this._widget.getLayoutInformation().getCurrentSizePolicy().isFixed()) {
          this._dataContentMeasure.innerHTML = this._localLongestText;
          elementRects = this._widget.getElement().getBoundingClientRect();
        }
        const height = elementRects.height;

        const layoutInfo = this._widget.getLayoutInformation();
        layoutInfo.setRawMeasure(width, height);
      }
    };
  });
});
